import { EDecorationType } from '../../../../../packages/JsonQuery';

export const DECORATIONS_LIST_MAP_VALUE_TO_LABEL = {
  [EDecorationType.Without]: 'Без отделки',
  [EDecorationType.PreFine]: 'Предчистовая отделка',
  [EDecorationType.Fine]: 'Чистовая отделка',
  [EDecorationType.FineWithFurniture]: 'Чистовая отделка c мебелью',
};
